var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"body"},[_c('Hero',{attrs:{"heroIcon":_vm.heroIcon}}),_c('h2',{staticClass:"titleTextAndMargin"},[_vm._v("Blog")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }